import React from "react";
import "./App.css";
import "./index.css";

import { Route, Routes, useLocation } from "react-router-dom";
import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";
import Home from "./components/home/Home";
import Pst_It_Solutions from "./components/pst_it_solutions/Pst_It_Solutions";
import Contact_Us from "./components/contact-us/Contact_Us";
import Interview_Guides from "./components/interview-guides/Interview_Guides";
import Blogs_Page from "./components/blogs-page/Blogs_Page";
import Blog_Details_Page from "./components/blogs-page/blog-details-page/Blog_Details_Page";
import Terms_Conditions from "./terms-conditions/Terms_Conditions";
import Privacy_Policy from "./components/privacy-policy/Privacy_Policy";
import Explore_Program from "./components/explore-program/Explore_Program";
import Claim_Certificate from "./components/claim-certificate/Claim_Certificate";
import Start_Quiz from "./components/start-quiz/Start_Quiz";
import Quiz_Page from "./components/quiz-page/Quiz_Page";
import Result_Page from "./components/result-page/Result_Page";
import ScrollToTop from "./components/scrolltotop/ScrollToTop";

function App() {
  const location = useLocation();

  // check if current path starts with /quiz-page/
  const hideFooter = location.pathname.startsWith("/quiz-page/");
  const hideHeader = location.pathname.startsWith("/quiz-page/");

  return (
    <>
      <ScrollToTop />
      {/* <Header /> */}
      {!hideHeader && <Header />}

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/pst-it-solutions" element={<Pst_It_Solutions />} />
        <Route path="/contact-us" element={<Contact_Us />} />
        <Route path="/interview-guides" element={<Interview_Guides />} />
        <Route path="/blogs" element={<Blogs_Page />} />
        <Route path="/blog/:id" element={<Blog_Details_Page />} />
        <Route path="/claim-certificate" element={<Claim_Certificate />} />
        <Route path="/terms-conditions" element={<Terms_Conditions />} />
        <Route path="/privacy-policy" element={<Privacy_Policy />} />
        <Route path="/explore-program/:id" element={<Explore_Program />} />
        <Route path="/start-quiz/:id" element={<Start_Quiz />} />
        <Route path="/quiz-page/:id" element={<Quiz_Page />} />
        <Route path="/result-page/:id" element={<Result_Page />} />
      </Routes>

      {!hideFooter && <Footer />}
    </>
  );
}

export default App;